import { RejectRequestAction } from "common/types/workflows";
import { required as hasValue } from "common/validate";

export const isRejectRequestActionValid = (action: RejectRequestAction) =>
  hasValue(action?.comments);
